<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['s1','s2']"
      :buttonItems="['add']"
      :columns="getChannelColumns()"
      :queryParams="queryParams"
      row-key="channelId"
      :leftSpace="10"
      :requestPromise="getChannelList"
    >
      <a-form-item slot="s1" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.channelPhone " placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="渠道名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.channelShopName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-button slot="add" type="primary" style="margin-left: 20px" @click="addEvent">+ 新建
      </a-button>
      <span slot="action" slot-scope="rowItem">
        <!--状态 0不允许补货 1允许补货 ,-->
        <a
          @click="toUpdateEvent(rowItem.record)">{{ rowItem.record.channelStatus === 0 ? '允许补货' : '撤销补货权限' }}</a>
         <a-divider type="vertical"/>
        <a @click="toEditEvent(rowItem.record)">编辑</a>
      </span>
    </search-page-view>
    <selected-product-dialog
      ref="channelList"
      :show="showSelectedDialog"
      :query-params="selectedQueryParams"
      :itemNames="['search_phone','search_proName']"
      @close="showSelectedDialog=false"
      :columns="getMerchantColumns()"
      title="选择渠道"
      :request-promise="getMerchantRequest"
    >
      <div style="margin-left: 22px;padding-bottom: 20px" slot="tips">温馨提示：渠道号仅能从分销员中选取</div>
      <a-form-item
        label="手机号"
        slot="search_phone" v-bind="searchItemLayout">
        <a-input
          v-model="selectedQueryParams.staffMobile"
          style="width: 170px"
          placeholder="请输入手机号"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="姓名"
        slot="search_proName"
        v-bind="searchItemLayout">
        <a-input
          v-model="selectedQueryParams.staffShopName"
          style="width: 170px"
          placeholder="请输入姓名"
        ></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button v-if="rowItem.record.staffAddStatus===1" disabled style="width: 80px">已添加</a-button>
        <a-button v-else type="primary" @click="onSelectedResult(rowItem.record)" style="width: 80px">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import smartMixins from './smartMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'ChannelManager',
  mixins: [smartMixins],

  components: { SelectedProductDialog },
  data() {
    return {
      showSelectedDialog: false,
      selectedQueryParams: {}
    }
  },

  created() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams = {
      merchantId: this.merchantId,
      platformId: this.getPlatformConfig().platformId
    }

  },
  mounted() {
  },
  methods: {
    addEvent() {
      this.selectedItem = undefined
      this.selectedQueryParams = {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        staffMobile: undefined,
        staffShopName: undefined
      }
      this.showSelectedDialog = true
      this.$nextTick(() => this.$refs.channelList.refresh(true))
    },
    getMerchantRequest(params) {
      const path = '/iot/channel/searchStaffList'
      return this.getHttpServices().getServerApiService().post(path, params)
    },

    toEditEvent(record) {
      this.selectedItem = record
      this.selectedQueryParams = {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        staffMobile: undefined,
        staffShopName: undefined
      }
      this.showSelectedDialog = true
      this.$nextTick(() => this.$refs.channelList.refresh(true))
    },
    toUpdateEvent(record) {
      this.getHttpServices().getServerApiService().post('/iot/channel/editIotChannelStatus', { channelId: record.channelId })
        .then(res => {
          this.$message.success('调整成功')
          this.$refs.pageList.refresh(false)
        }).catch(reason => {
        this.getLogUtils().errorWithTag('editIotChannelStatus', reason)
        this.showNetWorkErrorMessage(reason)
      })
    },
    getMerchantColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'staffId'
        },
        {
          title: '渠道名称(店铺名)',
          dataIndex: 'staffShopName'
        },
        {
          title: '联系人姓名',
          dataIndex: 'staffName'
        },
        {
          title: '联系人手机号',
          dataIndex: 'staffMobile'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    onSelectedResult(record) {
      const params = {
        channelId: this.selectedItem ? this.selectedItem.channelId : undefined,
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        channelName: record.staffName,
        channelPhone: record.staffMobile,
        channelShopName: record.staffShopName,
        staffId: record.staffId
      }
      this.getHttpServices().getServerApiService().post('/iot/channel/saveIotChannel', params)
        .then(res => {
          this.$message.success('新增成功')
          this.showSelectedDialog = false
          this.$refs.pageList.refresh(false)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getChannelList(params) {
      return this.getHttpServices().getServerApiService().post('/iot/channel/searchIotChannelList', params)
    },
    getChannelColumns() {
      return [
        {
          title: '渠道ID',
          dataIndex: 'staffId'
          // dataIndex: 'channelId'
        },
        {
          title: '渠道名称(店铺名)',
          dataIndex: 'channelShopName'
        },
        {
          title: '联系人姓名',
          dataIndex: 'channelName'
        },
        {
          title: '联系人手机号',
          dataIndex: 'channelPhone'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style scoped>
</style>